import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsAudioConference } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftTeamsAudioConferencingFieldConfigResource {
  private http = inject(HttpClient);

  getByTenantId(tenantId: number): Observable<MicrosoftTeamsAudioConference> {
    return this.http.get<MicrosoftTeamsAudioConference>(
      `/services/microsoft/field-configs/tenants/${tenantId}/teams-audio-conferences`,
    );
  }
}
